import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  visible: false,
  fromPage: '',
}

const navigateBackBarVisible = createSlice({
  name: 'navigateBackBarVisible',
  initialState,
  reducers: {
    toggleNavigateBackBar(state, action: PayloadAction<{ visible: boolean; fromPage: string }>) {
      state.visible = action.payload.visible
      state.fromPage = action.payload.fromPage
    },
  },
})

export const { toggleNavigateBackBar } = navigateBackBarVisible.actions

export default navigateBackBarVisible.reducer
